import { OctagonAlert } from 'lucide-react'
import { ReactNode } from 'react'

export function ErrorMessage({
  children,
  spanTwo,
}: {
  children: ReactNode | string
  spanTwo?: boolean
}) {
  return (
    <span
      className={`text-xs font-medium text-copy-error flex gap-1 items-center mt-1 ${spanTwo ? 'col-span-2' : ''}`}
    >
      <OctagonAlert className="text-copy-error w-4 h-4" />
      {children}
    </span>
  )
}
